{
  "name": "@pipecat-ai/client-js",
  "version": "1.11.0",
  "license": "BSD-2-Clause",
  "main": "dist/index.js",
  "module": "dist/index.module.js",
  "types": "dist/index.d.ts",
  "source": "index.ts",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/pipecat-ai/pipecat-client-web.git"
  },
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.module.js",
      "require": "./dist/index.js"
    }
  },
  "files": [
    "dist",
    "package.json",
    "README.md"
  ],
  "scripts": {
    "build": "jest --silent --passWithNoTests && parcel build --no-cache",
    "dev": "parcel watch",
    "lint": "eslint . --report-unused-disable-directives --max-warnings 0",
    "test": "jest"
  },
  "jest": {
    "preset": "ts-jest",
    "testEnvironment": "jsdom",
    "setupFilesAfterEnv": [
      "<rootDir>/tests/jest.setup.ts"
    ]
  },
  "devDependencies": {
    "@jest/globals": "^29.7.0",
    "@types/clone-deep": "^4.0.4",
    "@types/jest": "^29.5.12",
    "eslint": "^9.11.1",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^30.0.2",
    "ts-jest": "^29.2.5",
    "whatwg-fetch": "^3.6.20"
  },
  "dependencies": {
    "@types/events": "^3.0.3",
    "bowser": "^2.11.0",
    "clone-deep": "^4.0.1",
    "events": "^3.3.0",
    "typed-emitter": "^2.1.0",
    "uuid": "^11.1.1"
  }
}
